// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

// CONFIGURAÇÃO CRÍTICA PARA O ENDEREÇO /siaap
// Se estiver em produção (no site apmbb.com.br), usa '/siaap' como base.
// Se estiver no seu computador (localhost), usa '/' como base.
const BASE_PATH = process.env.NODE_ENV === 'production' ? "/siaap" : "/"; 

root.render(
  <React.StrictMode>
    {/* O basename diz ao React para ignorar o "/siaap" inicial da URL e tratar o restante como rotas do App */}
    <BrowserRouter basename={BASE_PATH}> 
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
serviceWorkerRegistration.register({
  onUpdate: registration => {
    console.log("Nova atualização do Service Worker encontrada!");
    
    // 1. Força o novo Service Worker a assumir o controle imediatamente
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    
    // 2. Limpa todo o cache do PWA gravado no celular
    if ('caches' in window) {
      caches.keys().then((names) => {
        for (let name of names) caches.delete(name);
      });
    }

    // 3. Força o recarregamento da página para puxar os arquivos novos
    window.location.reload(true);
  }
});